(() => {
  document.documentElement.classList.remove('no-js');
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const strings = window.themeStrings || {};
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const variantLabel = value => String(value || '').split(' / ').map(part => strings.colors?.[part] || part).join(' / ');
  const rootPath = () => (window.Shopify?.routes?.root || strings.routesRoot || '/').replace(/\/?$/, '/');
  function path(value) {
    if (!value) return rootPath();
    if (/^(?:https?:|mailto:|tel:|#|\/\/)/.test(value)) return value;
    const normalized = '/' + value.replace(/^\/+/, '');
    const root = rootPath();
    return root !== '/' && (normalized === root.slice(0,-1) || normalized.startsWith(root)) ? normalized : root + normalized.slice(1);
  }
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang, {style:'currency', currency:document.body.dataset.currentCurrency || 'DKK'}).format(Number(cents || 0) / 100);
  }
  async function request(url, options = {}) {
    const response = await fetch(path(url), {...options, headers:{Accept:'application/json', ...options.headers}});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || strings.cartError);
    return data;
  }
  let cartReturnFocus;
  let cartSequence = 0;
  let cartBusy = false;
  let cartPageNeedsRefresh = false;
  function setDrawer(open) {
    const drawer = $('[data-cart-drawer]');
    if (!drawer) return;
    if (open) cartReturnFocus = document.activeElement;
    drawer.inert = !open;
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('drawer-open', open);
    ['[data-site-header]', '[data-club-header]', '#MainContent', '.site-footer'].forEach(selector => { const el = $(selector); if (el) el.inert = open; });
    if (open) $('button[data-cart-close]', drawer)?.focus();
    else if (cartPageNeedsRefresh && document.body.classList.contains('template-cart')) { window.location.reload(); }
    else cartReturnFocus?.focus();
  }
  function cartError(error) {
    const el = $('[data-cart-error]');
    if (el) { el.textContent = error?.message || strings.cartError; el.hidden = !error; }
  }
  function shipping(cart) {
    const threshold = Number(document.body.dataset.freeShippingThreshold || 0);
    if (!threshold) return '';
    const remaining = Math.max(0, threshold - cart.total_price);
    const text = remaining ? strings.freeShippingRemaining.replace('{{ amount }}', money(remaining)) : strings.freeShippingUnlocked;
    return `<div class="shipping-progress"><p>${escape(text)}</p><div class="shipping-progress__bar"><span style="--progress:${Math.min(100, cart.total_price / threshold * 100)}%"></span></div></div>`;
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count || ''; });
    const count = $('[data-cart-drawer-count]');
    if (count) count.textContent = cart.item_count ? `(${cart.item_count})` : '';
    const items = $('[data-cart-items]'), footer = $('[data-cart-footer]');
    if (!items || !footer) return;
    const active = document.activeElement;
    const focusKey = active?.dataset.cartChange;
    const focusAction = active?.dataset.action;
    if (!cart.items.length) {
      items.innerHTML = `<div class="cart-empty"><p>${escape(strings.cartEmpty)}</p><a class="button button--dark" href="${escape($('[data-club-header]')?.dataset.clubUrl || path('collections/all'))}">${escape(strings.continueShopping)}</a></div>`;
      footer.innerHTML = '';
    } else {
      items.innerHTML = cart.items.map(item => `<article class="drawer-item"><a href="${escape(path(item.url))}">${item.image ? `<img src="${escape(item.image)}" width="82" height="103" alt="${escape(item.product_title)}">` : ''}</a><div><strong><a href="${escape(path(item.url))}">${escape(item.product_title)}</a></strong><p>${escape(variantLabel(item.variant_title))}</p><div class="drawer-item__qty"><button type="button" data-cart-change="${escape(item.key)}" data-action="decrease" data-quantity="${item.quantity-1}" aria-label="${escape(strings.decrease)}: ${escape(item.product_title)}">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${escape(item.key)}" data-action="increase" data-quantity="${item.quantity+1}" aria-label="${escape(strings.increase)}: ${escape(item.product_title)}">+</button></div></div><div class="drawer-item__price"><strong>${escape(money(item.final_line_price))}</strong><button type="button" class="plain-button" data-cart-change="${escape(item.key)}" data-action="remove" data-quantity="0">${escape(strings.remove)}</button></div></article>`).join('');
      footer.innerHTML = `${shipping(cart)}<p class="cart-subtotal"><strong>${escape(strings.subtotal)}</strong><span>${escape(money(cart.total_price))}</span></p><p>${escape(strings.currencyNote)}</p><form action="${path('cart')}" method="post"><button class="button button--dark" type="submit" name="checkout">${escape(strings.checkout)}</button></form><a class="cart-view-link" href="${path('cart')}">${escape(strings.viewCart)}</a>`;
    }
    if (focusKey) ($$('[data-cart-change]').find(el => el.dataset.cartChange === focusKey && el.dataset.action === focusAction) || $('button[data-cart-close]'))?.focus();
    document.dispatchEvent(new CustomEvent('cart:updated', {detail:cart}));
  }
  async function refreshCart() {
    const sequence = ++cartSequence;
    try { const cart = await request('cart.js'); if (sequence === cartSequence) { renderCart(cart); cartError(null); } }
    catch(error) { cartError(error); }
  }
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.product-form, .quick-add-form');
    if (!form || !document.body.classList.contains('ajax-cart-enabled')) return;
    event.preventDefault();
    const buttons = [...form.elements].filter(el => el.type === 'submit');
    if (form.dataset.submitting) return;
    form.dataset.submitting = 'true';
    buttons.forEach(button => { button.disabled = true; });
    let errorBox = $('[data-form-error]', form);
    if (!errorBox) { errorBox = document.createElement('p'); errorBox.dataset.formError = ''; errorBox.setAttribute('role','alert'); form.append(errorBox); }
    errorBox.textContent = '';
    try { await request('cart/add.js', {method:'POST', body:new FormData(form)}); cartPageNeedsRefresh = true; setDrawer(true); await refreshCart(); }
    catch(error) { errorBox.textContent = error.message || strings.cartError; }
    finally { delete form.dataset.submitting; buttons.forEach(button => { button.disabled = button.dataset.unavailable === 'true'; }); }
  });
  document.addEventListener('click', async event => {
    const target = event.target;
    if (target.closest('[data-cart-open]') && $('[data-cart-drawer]')) { event.preventDefault(); setDrawer(true); refreshCart(); }
    if (target.closest('[data-cart-close]')) { event.preventDefault(); setDrawer(false); }
    const change = target.closest('[data-cart-change]');
    if (change && !cartBusy) {
      event.preventDefault(); cartBusy = true; ++cartSequence; cartError(null);
      const drawer = $('[data-cart-drawer]'); drawer.setAttribute('aria-busy','true');
      $$('[data-cart-change]').forEach(el => el.disabled = true);
      try { cartPageNeedsRefresh = true; renderCart(await request('cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:change.dataset.cartChange,quantity:Number(change.dataset.quantity)})})); }
      catch(error) { cartError(error); }
      finally { cartBusy = false; drawer.removeAttribute('aria-busy'); $$('[data-cart-change]').forEach(el => el.disabled = false); }
    }
    const mobile = target.closest('[data-mobile-toggle]');
    if (mobile) { const header = mobile.closest('.site-header'); const open = header.classList.toggle('is-open'); mobile.setAttribute('aria-expanded', String(open)); $('#MobileMenu', header)?.setAttribute('aria-hidden', String(!open)); }
    const search = target.closest('[data-search-toggle]');
    if (search) { const wrap = search.closest('.search-popover'); const open = wrap.classList.toggle('is-open'); search.setAttribute('aria-expanded', String(open)); if (open) $('[data-predictive-input]', wrap)?.focus(); }
    const filter = target.closest('[data-filter-toggle]');
    if (filter) { const open = document.body.classList.toggle('filter-open'); $$('[data-filter-toggle]').forEach(el => el.setAttribute('aria-expanded',String(open))); }
    const thumb = target.closest('[data-product-thumb]');
    if (thumb) activateMedia(thumb.closest('[data-product-root]'), thumb.dataset.mediaId);
    const zoomTrigger = target.closest('[data-zoom-image]');
    const image = zoomTrigger ? $('img',zoomTrigger) : target.closest('[data-product-media].is-active img');
    if (image) {
      const dialog = document.createElement('dialog'); dialog.className = 'product-zoom';
      const close = document.createElement('button'); close.textContent = '×'; close.setAttribute('aria-label',strings.close); close.type = 'button';
      const zoom = document.createElement('img'); zoom.src = image.currentSrc || image.src; zoom.alt = image.alt;
      dialog.append(close,zoom); document.body.append(dialog); dialog.showModal(); close.focus();
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { dialog.remove(); $('[data-product-thumb].is-active')?.focus(); });
    }
  });
  document.addEventListener('keydown', event => {
    const drawer = $('[data-cart-drawer][aria-hidden="false"]');
    if (event.key === 'Tab' && drawer) {
      const focusable = $$('a[href],button:not([disabled]),input:not([disabled])',drawer).filter(el => el.getClientRects().length);
      const first = focusable[0], last = focusable.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
    if (event.key !== 'Escape') return;
    if (drawer) setDrawer(false);
    document.body.classList.remove('filter-open');
    $$('.search-popover.is-open').forEach(el => { el.classList.remove('is-open'); const button = $('[data-search-toggle]',el); button.setAttribute('aria-expanded','false'); button.focus(); });
    $$('.site-header.is-open').forEach(el => { el.classList.remove('is-open'); $('[data-mobile-toggle]',el)?.setAttribute('aria-expanded','false'); $('#MobileMenu',el)?.setAttribute('aria-hidden','true'); });
  });
  function activateMedia(root, id) {
    $$('[data-product-media]',root).forEach(el => { const active = String(el.dataset.mediaId) === String(id); el.classList.toggle('is-active',active); el.hidden = !active; });
    $$('[data-product-thumb]',root).forEach(el => { const active = String(el.dataset.mediaId) === String(id); el.classList.toggle('is-active',active); el.setAttribute('aria-pressed',String(active)); });
  }
  function mediaSignature(source) {
    const name = decodeURIComponent(String(source || '').split('?')[0].split('/').pop()).toLowerCase().replace(/\.[a-z0-9]+$/, '');
    return name.replace(/[-_][a-f0-9]{10,}(?:_\d+)?$/, '').replace(/-(?:front|back|left|right|side|top|bottom|detail|closeup|flat|flatlay|outside|inside)(?:-(?:front|back|left|right|side|top|bottom|detail|closeup|flat|flatlay|outside|inside|and|[0-9]+))*$/, '');
  }
  function filterVariantMedia(root, variants, colorIndex, color, selected) {
    const thumbs = $$('[data-product-thumb]',root);
    const groups = new Map();
    for (const variant of variants) {
      const key = colorIndex >= 0 ? variant.options[colorIndex] : '__single';
      if (!groups.has(key)) groups.set(key, new Set());
      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      if (mediaId) groups.get(key).add(String(mediaId));
    }
    const chosenKey = colorIndex >= 0 ? color : '__single';
    const chosen = groups.get(chosenKey) || new Set();
    const signatureGroups = new Map();
    for (const thumb of thumbs) {
      for (const [key,ids] of groups) {
        if (!ids.has(thumb.dataset.mediaId)) continue;
        const signature = mediaSignature(thumb.dataset.mediaSource);
        if (!signatureGroups.has(signature)) signatureGroups.set(signature, new Set());
        signatureGroups.get(signature).add(key);
      }
    }
    for (const thumb of thumbs) {
      const directGroups = [...groups].filter(([,ids]) => ids.has(thumb.dataset.mediaId)).map(([key]) => key);
      const signatureMatches = signatureGroups.get(mediaSignature(thumb.dataset.mediaSource));
      const visible = groups.size <= 1 || chosen.has(thumb.dataset.mediaId) || (!directGroups.length && signatureMatches?.size === 1 && signatureMatches.has(chosenKey));
      thumb.hidden = !visible;
    }
    const preferred = String(selected?.featured_media?.id || selected?.featured_image?.id || '');
    const first = thumbs.find(t => !t.hidden && t.dataset.mediaId === preferred) || thumbs.find(t => !t.hidden);
    if (first) activateMedia(root,first.dataset.mediaId);
  }
  function init(scope = document) {
    $$('[data-product-root]',scope).forEach(root => {
      if (root.dataset.initialized) return; root.dataset.initialized = 'true';
      const variants = JSON.parse($('[data-variant-json]',root)?.textContent || '[]');
      const form = $('.product-form',root); if (!form) return;
      $$('[data-option-role="size"] .option-values',root).forEach(group => {
        const order = ['XXS','XS','S','M','L','XL','2XL','XXL','3XL','XXXL','4XL','5XL'];
        [...group.children].sort((a,b) => { const av = $('input',a)?.value, bv = $('input',b)?.value; const ai = order.indexOf(av), bi = order.indexOf(bv); return ai >= 0 && bi >= 0 ? ai-bi : Number(av)-Number(bv); }).forEach(el => group.append(el));
      });
      let previousColor;
      const colorIndex = Number($('[data-option-role="color"]',root)?.dataset.optionIndex ?? -1);
      function update(initial = false) {
        const options = $$('[data-option-index]',root).map(group => $('input:checked',group)?.value);
        const variant = variants.find(v => !options.length || v.options.every((value,index) => value === options[index]));
        const buttons = $$('[data-add-button]',root), prices = $$('[data-product-price]',root), id = $('input[name="id"]',form);
        buttons.forEach(button => { button.disabled = !variant?.available; button.dataset.unavailable = String(!variant?.available); button.textContent = !variant ? strings.unavailable : variant.available ? strings.addToCart : strings.soldOut; });
        $$('[data-sticky-variant]',root).forEach(el => { el.textContent = variant ? variantLabel(variant.public_title || variant.title) : strings.unavailable; });
        if (id) { id.disabled = !variant; if (variant) id.value = variant.id; }
        const color = $('[data-option-role="color"] input:checked',root)?.value;
        $$('[data-selected-color]',root).forEach(el => el.textContent = $('[data-option-role="color"] input:checked',root)?.dataset.displayLabel || color || '');
        if (initial || color !== previousColor) filterVariantMedia(root,variants,colorIndex,color,variant || variants.find(v => v.options[colorIndex] === color));
        previousColor = color;
        if (!variant) return;
        prices.forEach(price => { price.innerHTML = `${variant.compare_at_price > variant.price ? `<span class="price__compare">${escape(money(variant.compare_at_price))}</span>` : ''}<span>${escape(money(variant.price))}</span>`; });
        if (!initial) { const url = new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url); }
      }
      root.addEventListener('change',event => { if (event.target.matches('[data-option-input]')) update(); });
      update(true);
    });
    $$('[data-predictive-input]',scope).forEach(input => {
      if (input.dataset.initialized) return; input.dataset.initialized = 'true'; let timer, controller;
      input.addEventListener('input', () => {
        clearTimeout(timer); controller?.abort();
        const results = $('[data-predictive-results]',input.closest('.search-popover')); if (!results) return;
        const query = input.value.trim(); if (query.length < 2) { results.innerHTML = ''; return; }
        timer = setTimeout(async () => {
          controller = new AbortController();
          try { const data = await request(`search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title`, {signal:controller.signal});
            if (input.value.trim() !== query) return;
            results.innerHTML = (data.resources.results.products || []).map(product => `<a class="predictive-result" href="${escape(path(product.url))}">${product.image ? `<img src="${escape(product.image)}" width="56" height="56" alt="">` : '<span></span>'}<span>${escape(product.title)}</span></a>`).join('') || `<p>${escape(strings.noResults)}</p>`;
          } catch(error) { if (error.name !== 'AbortError') results.innerHTML = ''; }
        },180);
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load',event => init(event.target));
  window.addEventListener('pageshow', () => { if ($('[data-cart-drawer][aria-hidden="false"]')) refreshCart(); });
})();
